import React, { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import stilePulsanti from "../interfaccia/stilePulsanti";
import ListaSemplice from './ListaSemplice';
import apiUrl from '../Apiurl';
import ContainerLoaderCharts from '../logistica/Charts/ContainerLoaderCharts';
import apriUrl from '../interfaccia/funzioniComuni/apriUrl';

function ContainerBarraELista({ 
    query,
    titolo,
    input,
    charts,
    setInput,
    hideInputData }) {

    const [data, setData] = useState(false)
    const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState("");
    
    const handleChange = async function (evt) {
        const value = evt.target.value;
        try {
                setInput({
                    ...input,
                    [evt.target.name]: value
                });
        } catch (err) {
            console.log("Errore nell'aggiornamento di un dato non nestato: " + err)
            throw err;
        }
    }

    useEffect(() => {
        const getUserMetadata = async () => {

            try {
                const accessToken = await getAccessTokenSilently();
                setToken(accessToken);
            } catch (e) {
                console.log(e.message);
            }
        };

        getUserMetadata();


    }, [getAccessTokenSilently, user?.sub]);


    useEffect(() => {
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        let data1 = new Date(input.dataStart);
        let data2 = new Date(input.dataEnd)
        if (data1<=data2) {
            fetch(apiUrl + "/contab/get/"+ query + "?" + new URLSearchParams(input), { headers: { Authorization: "Bearer " + token } }) // sostituire url della richiesta con quella giusta
            .then(resp => resp.json())
            .then(data => setData(data))
        } else {
            alert("Assicurati che la seconda data sia posteriore alla prima")
        }
    }, [token, input, query]);


    function ricercaOrdini() {
        let data1 = new Date(input.dataStart);
        let data2 = new Date(input.dataEnd)
        if (data1<=data2) {
        fetch(apiUrl + "/contab/get/"+ query +"?" + new URLSearchParams(input), { headers: { Authorization: "Bearer " + token } })
            .then(resp => resp.json())
            .then(data => {
                setData(data.data);
            })
        } else {
            alert("Assicurati che la seconda data sia posteriore alla prima")
        }
    }


    const getCSV = async function () {
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        try {
            let data1 = new Date(input.dataStart);
            let data2 = new Date(input.dataEnd);
            if (data1<=data2) {
            fetch(apiUrl + "/contab/csv/"+ query +"?" + new URLSearchParams(input), { headers: { Authorization: "Bearer " + token } })
            .then(resp => resp.json())
            .then(data => apriUrl(data))
            } else {
                alert("Assicurati che la seconda data sia posteriore alla prima")
            }
        } catch (err) {
            console.log("Errore nel get del csv': " + err)
            throw err;
        }
    }

    const {
        inputClassesRicercaOrizzontale
    } = stilePulsanti

    return (
        <div className="pa2">
            {titolo && <h3 className="tc sfondoColChiaro pa2 b">{titolo}</h3>}
            <div className='tc flex items-center justify-center'>
                {!hideInputData && <div className='tc flex items-center justify-center'><span className='pl2'>Da data: </span>
                    <input
                        type="date"
                        onChange={handleChange}
                        name="dataStart"
                        className={inputClassesRicercaOrizzontale}
                        value={input.dataStart}
                    ></input>
                    <span className='pl2'> a data: </span>
                    <input
                        type="date"
                        onChange={handleChange}
                        name="dataEnd"
                        className={inputClassesRicercaOrizzontale}
                        value={input.dataEnd}
                    ></input>
                <div className='dim pointer gruppoInputRicercaOrizzontale mr2' onClick={ricercaOrdini}>
                    <button className="dim tastoInputOrizzontale br3 mr2">Cerca</button>
                    <span className='nonSelezionabile'>Cerca</span>
                </div></div>}
                    
                <div className='dim pointer gruppoInputRicercaOrizzontale mr2' onClick={getCSV}>
                    <button className=" tastoInputOrizzontale br3 mr2">CSV</button>
                    <span className='nonSelezionabile'>Scarica CSV</span>
                </div>
            </div>
            <div className='sfondoBiancoTema'>
                {charts && <ContainerLoaderCharts 
                                query={`/contab/charts/${query}?`+ new URLSearchParams(input)} 
                                titolo={titolo} 
                                displayTitolo={false} 
                                tipo={query}
                                dataLista={data} //questo serve solo per il refresh dei dati
                            />}
            </div>
            <div className='sfondoBiancoTema'>
                {data && <ListaSemplice data={data} tipoQuery={query}/>}
            </div>
        </div>
    )
}

export default ContainerBarraELista;
